import { RigContractStatusBase } from './base/rig-contract-status-base';

export class RigContractStatus extends RigContractStatusBase { }